import Instance from '../../../Axios';

// New Actions for the app

const GetMenu = (id) => async (dispatch) => {
  console.log('id', id);
  await Instance()
    .get(`/backend/menus/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_MENU', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetMenu;
